/*
 * Course occasions (EduAdmin)
 *
 * The EduAdmin course page (/eduadmin/{course}__{id}/?eid={event}) only lists the chosen
 * event. Fetch the same page without ?eid, which the plugin renders with every event
 * grouped by city, and list the other occasions in the same city below the chosen one.
 */
export default class CourseOccasions {
	static async init() {
		const detail = document.querySelector('.eduadmin.detail-view[data-eventid]');

		if (!detail || !detail.dataset.eventid) {
			return;
		}

		const currentList = detail.querySelector('.eventDays');
		const currentItem = currentList && currentList.querySelector('.eventItem');
		const currentCity = currentItem && this.getCity(currentItem);

		if (!currentItem || !currentCity) {
			return;
		}

		const currentStart = this.getStart(currentItem);
		const url = new URL(window.location.href);
		url.searchParams.delete('eid');

		let doc;
		try {
			const response = await fetch(url.toString(), { credentials: 'same-origin' });
			if (!response.ok) {
				return;
			}
			doc = new DOMParser().parseFromString(await response.text(), 'text/html');
		} catch (e) {
			return;
		}

		const others = Array.from(doc.querySelectorAll('.eventDays .eventItem')).filter(
			(item) => this.getCity(item) === currentCity && this.getStart(item) !== currentStart
		);

		if (!others.length) {
			return;
		}

		const titleTemplate = (window.trombCourseOccasions && window.trombCourseOccasions.title) || 'Fler kurstillfällen i %s';

		const section = document.createElement('div');
		section.className = 'eduadmin m-courseOccasions';

		const heading = document.createElement('h3');
		heading.className = 'm-courseOccasions__title';
		heading.textContent = titleTemplate.replace('%s', currentCity);

		const list = document.createElement('div');
		list.className = 'event-table eventDays';
		others.forEach((item) => list.appendChild(document.importNode(item, true)));

		section.append(heading, list);
		detail.append(section);
	}

	// City is either the separator heading above the item (grouped by city) or a column in the item itself
	static getCity(item) {
		const cityColumn = item.querySelector('.eventCity');
		if (cityColumn) {
			return cityColumn.firstChild ? cityColumn.firstChild.textContent.trim() : '';
		}

		let previous = item.previousElementSibling;
		while (previous && !previous.classList.contains('eventSeparator')) {
			previous = previous.previousElementSibling;
		}

		return previous ? previous.textContent.trim() : '';
	}

	static getStart(item) {
		const date = item.querySelector('[data-startdate]');
		return date ? date.dataset.startdate : '';
	}
}
